import React, { useCallback, useEffect } from "react";
import { IFrame } from "../../../components/templates";
import { observer, useLocalObservable } from "mobx-react-lite";
import { Store } from "./store";
import { useGlobalStore } from "../../../contexts/globalStoreContext";
import { Grid, GridItem, useScreenSize } from "@telefonica/mistica";
import { LoadingContainer } from "../../../components";
import { useNavigateCustom } from "../../../hooks";
import { useLocation } from "react-router-dom";

interface OnboardingCafRouteProps {
	resendDocument?: boolean;
}

const OnboardingCaf: React.FC = observer(() => {
	const { authenticationStore, fraudAnalysisStore } = useGlobalStore();
	const routeProps = useLocation().state as OnboardingCafRouteProps;
	const resendDocument = routeProps.resendDocument ? true : false;

	const store = useLocalObservable(
		() => new Store(authenticationStore, () => navigate("/fintech-registration/validate-documents/under-analysis")),
	);

	const navigate = useNavigateCustom();
	const { isMobile } = useScreenSize();

	const handlePostFraudAnalysis = useCallback(() => {
		store.postFraudAnalysis.fetch();
	}, []);

	useEffect(() => {
		if (fraudAnalysisStore.statusReason !== null || resendDocument || store.isResendDocumentValue) {
			return handlePostFraudAnalysis();
		} else {
			store.getFraudAnalysis.fetch();
		}
	}, [resendDocument]);


	useEffect(() => {
		window.addEventListener(
			"message",
			(event) => {
				if (event.data?.code === "ONBOARDING_FINISHED") {
					window.removeEventListener("message", () => { });
					navigate("/fintech-registration/validate-documents/under-analysis");
				}
			},
			false,
		);
	}, []);

	return (
		<>
			{
				store.isLoading
					? (
						<Grid justifyContent="center">
							<Grid height={isMobile ? 488 : 600} alignItems="center">
								<GridItem>
									<LoadingContainer title="" />
								</GridItem>
							</Grid>
						</Grid>
					)
					:
					store.userOnboardURL.value && (
						<IFrame iframeSourceUrl={store.userOnboardURL.value} />
					)
			}
		</>
	);
});

export default OnboardingCaf;
